<template>
  <div />
</template>

<script>

/**
 * Vue: Country selector (country-selector)
 * -----------------------------------------------------------------------------
 * Country selector dropdown that changes the
 * selected Shopify market using localization form.
 *
 */
import { nextTick } from 'vue'

export default {
  name: 'CountrySelector',

  props: {
    sectionId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selectors: {},
    }
  },

  mounted() {
    this.setSelectors()
    this.setSelectChangeHandler()

    /**
     * set's the width of the select drop down
     */
    nextTick().then(() => {
      this.setSelectWidth()
    })
  },

  methods: {

    /**
     * Set selectors.
     */
    setSelectors() {
      const container = document.querySelector(`[js-country-selector="${this.sectionId}`)

      this.selectors = {
        container,
        form: container.querySelector('[js-country-selector="form"]'),
        select: container.querySelector('[js-country-selector="select"]'),
        returnTo: container.querySelector('[js-country-selector="returnTo"]'),
      }
    },

    /**
     * Set country selector change event handler.
     * Preserve current path and url params by setting return_to value.
     */
    setSelectChangeHandler() {
      this.selectors.select.addEventListener('change', () => {
        this.setSelectWidth()
        this.selectors.returnTo.value = `${window.location.pathname}${window.location.search}`
        this.selectors.form.submit()
      })
    },

    /**
     * Set width of sort element based on select option
     */
    setSelectWidth() {
      nextTick().then(() => {
        if (!this.selectors.select) {
          return
        }

        const widthElement = document.createElement('span')
        widthElement.innerHTML = this.selectors.select.options[this.selectors.select.selectedIndex].text || ''
        document.body.appendChild(widthElement)

        const width = widthElement.offsetWidth + 16
        document.body.removeChild(widthElement)

        if (width === 0) {
          return
        }

        this.selectors.select.style.width = `${width}px`
      })
    },
  },
}
</script>

<style lang="scss">
@import './country-selector';
</style>
